module.exports = __webpack_public_path__ + "img/guanyin.2cdd295d.jpg";